import { MantineProvider } from '@mantine/core';
import { PropsWithChildren, useEffect } from 'react';
import { LemonadeProvider } from '@percent/lemonade';
import tinycolor from 'tinycolor2';
import { useNominationForm } from '@percent/grants-nomination-form/hooks';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';

const defaultColors = {
  primaryColor: '#000000',
  secondaryColor: '#F5F5F6',
};

// Exactly 10 elements required by Mantine
const fillColor = (color: string) => [color, color, color, color, color, color, color, color, color, color] as const;

const getAccent = (color: string, amount: number) =>
  tinycolor(color).isDark() ? tinycolor(color).brighten(amount).toString() : tinycolor(color).darken(amount).toString();

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const { nominationFormData } = useNominationForm();

  const { primaryColor, secondaryColor } = nominationFormData || defaultColors;

  const formTitle = nominationFormData?.title || nominationFormData?.programName;

  useEffect(() => {
    if (nominationFormData?.logo) {
      const favicon = document.getElementById('favicon') as HTMLLinkElement;

      if (favicon) {
        favicon.href = nominationFormData.logo;
      }
    }

    if (formTitle) {
      document.title = formTitle;
    }
  }, [nominationFormData?.logo, formTitle]);

  return (
    <MantineProvider
      theme={{
        primaryColor: 'primary',
        colors: {
          // Hardcoding it for now to avoid adding additional dependencies, might add @mantine/colors-generator later if needed
          primary: fillColor(primaryColor),
          secondary: fillColor(secondaryColor),
        },
      }}
    >
      <LemonadeProvider
        customPalette={{
          primary100: getAccent(primaryColor, 80),
          primary400: primaryColor,
          primary600: getAccent(primaryColor, 15),
        }}
      >
        {children}
      </LemonadeProvider>
    </MantineProvider>
  );
};
